import Connector, { takeQuery } from '../../agent';
import types from './types';

const BatchUpdate = {
  getPossibleFieldsBatchUpdate: () => {
    return Connector.api.get(`/inventoryBatchUpdate/possibleFields`);
  }
};

const batchUpdateSagas = [
  takeQuery(types.GAT_POSSIBLE_FIELDS_LIST_BATCH_UPDATE, BatchUpdate.getPossibleFieldsBatchUpdate)
];

export default batchUpdateSagas;
